// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ec692ed6","128":"78538c25","486":"fe3fefe6","822":"fd7c057c","867":"9310adb7"}[chunkId] + ".chunk.js";
};